/**
 * Editing a filed inspection (Jim 10/22): the server already holds the
 * corrective actions this very visit raised, so they came back under the
 * question as "open from before" with a Verify button, and a deleted one
 * blocked answering Yes until the revise re-sync dropped it. The visit's own
 * rows live in the form's answers; the open list must not show them twice.
 */
export function withoutOwnActions<
  T extends { created_by_inspection_id?: string | null },
>(rows: T[] | undefined, editInspectionId: string | null): T[] | undefined {
  if (!rows || !editInspectionId) return rows;
  return rows.filter((r) => r.created_by_inspection_id !== editInspectionId);
}
